<template>
  <div class="main-box main-min-height bgffffff">
    <div class="table-box">
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row>
            <el-col :span="5">
              <el-form-item prop="createBy" label="录入人">
                <el-input v-model="searchForm.createBy" placeholder="-请输入-" style="width:100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="merchantId" label="所属商铺">
                <el-select clearable v-model="searchForm.merchantId" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in BusinessList" :key="item.id" :label="item.fulName" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo(true)">
                  查询
                </el-button>
                <el-button type="primary" @click="Edit(false)">
                  添加
                </el-button>
                <el-button type="danger" @click="del(false)">
                  删除
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :header-cell-style="{background:'#F4F4F5'}" :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%">
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <el-table-column label="录入人" prop="createBy" align="center"></el-table-column>
        <el-table-column label="录入时间" prop="createTime" align="center"></el-table-column>
        <el-table-column label="商铺" prop="fullName" align="center"></el-table-column>
        <el-table-column label="录入金额" prop="money" align="center"></el-table-column>
        <el-table-column label="计提金额" prop="accrual" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{row}">
            <el-button size="mini" type="danger" @click="del(true,row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination location='left' :page='page' @getData="getInfo" />
    </div>
    <Dialogs v-model="dialogEditVisible" :center='true' :title='title' :HeaderPosition='true' width-dial="700px" :height-dial="150" @dialog="submit">
      <el-form size='mini' :model="ruleForm" :rules="rules" ref="ruleForm" label-position='right' label-width="100px">
        <el-row>
           <el-col :span="24">
            <el-form-item>
              <span>{{info}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="merchantId" label="商务全称">
              <el-select clearable v-model="ruleForm.merchantId" placeholder="请选择" @change="handlechange" style="width:100%">
                <el-option v-for="item in BusinessList" :key="item.id" :label="item.fulName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="createTime" label="录入时间">
              <el-date-picker v-model="ruleForm.createTime" type="date" format='yyyy-MM-dd' value-format="yyyy-MM-dd" style="width:100%" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="money" label="录入金额">
              <el-input v-model="ruleForm.money" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="accrual" label="计提金额">
              <el-input v-model="ruleForm.accrual" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Dialogs>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/Pagination.vue'
import Dialogs from '@/components/DiaLogs'

export default {
  name: 'OfflineAmount',
  components: {
    Pagination,
    Dialogs
  },
  data() {
    return {
      searchForm: {
        createBy: null,//录入人
        merchantId: null,//商铺Id
      },//查询条件
      tableData: [],//表格参数
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      info:null,//商铺详情
      BusinessList: [],
      dialogEditVisible: false,
      ruleForm: {
        createTime: "",
        merchantId: "",
        money: 0,
        accrual: 0,
      },
      rules: {
        createTime: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        merchantId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        shopsId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        money: [
          { required: true, message: '请输入此次录入金额', trigger: 'blur' }
        ],
        accrual: [
          { required: true, message: '请输入此次计提金额', trigger: 'blur' }
        ],
      },
      title: '新增',
      multipleSelection: []
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getInfo()
    this.getBusiness()
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$OfflineAmount.list(
        {
          ...this.searchForm,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
    //获取商户列表
    getBusiness() {
      this.$MerchantManagement.total().then(({ data }) => {
        if (data.code === 200) {
          this.BusinessList = data.result
        }
      })
    },
    //
    handlechange(e) {
      this.$OfflineAmount.queryAgriculturalProductsHallPastSum({id:e}).then(({data})=>{
        if(data.code===200){
          this.info = data.result
        }
      })
    },
    //提交
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$OfflineAmount.add({ ...this.ruleForm }).then(({ data }) => {
            if (data.code === 200) {
              this.messages(data.message, true, 1000, () => {
                this.getInfo();
                this.dialogEditVisible = false
              })
            }
          })
        }
      });
    },
    Edit(bool, data) {
      Object.keys(this.ruleForm).forEach(item => this.ruleForm[item] = null)
      this.ruleForm.money = 0;
      this.ruleForm.accrual = 0;
      bool ? this.title = '修改商户信息' : this.title = '添加商户信息'
      if (bool) {
        Object.keys(this.ruleForm).forEach(item => this.ruleForm[item] = data[item])
      }
      this.dialogEditVisible = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    del(type, id) {
      let ids = null;
      if (type) {
        ids = id
      } else {
        ids = this.multipleSelection
          .reduce((total, item) => {
            total += item.id + ",";
            return total;
          }, "")
          .slice(0, -1);
      }
      this.$OfflineAmount.deleteBatch({ ids }).then(({ data }) => {
        if (data.code === 200) {
          this.messages(data.message, true, 1000)
          this.getInfo()
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
</style>
